export default __webpack_public_path__ + "static/media/Conexia.260f0a55.jpg";